import { InternationalTopUpOffer } from './international-top-up-offer.interface';
import { InternationalTopUpOperator } from './international-top-up-operator.interface';

export interface InternationalTopUpOffersOrOperators {
    offers: InternationalTopUpOffer[];
    operators: InternationalTopUpOperator[];
}
